var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH672(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{stroke:#cecece;stroke-dasharray:0 0 0 8.5;stroke-width:5.67px;}.cls-1,.cls-2{fill:none;stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:#ffdf97;}.cls-4{fill:#ea8b49;}.cls-5,.cls-6{fill:#fff;}.cls-7{fill:#ffbf57;}.cls-8{fill:#efecea;}.cls-9{fill:#d37a3d;}.cls-10,.cls-11{fill:#6dd3ce;}.cls-11{mix-blend-mode:screen;}.cls-6{opacity:0;}.cls-12{isolation:isolate;}.cls-2{stroke:#ffd15c;stroke-width:8.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M158.94,132.13l-6.04-3.73c-1.02-.63-1.23-2.03-.42-2.93l1.88-2.1c.97-1.09,.43-2.82-.99-3.16l-25.51-6.11c-1.62-.39-2.94,1.32-2.15,2.79l11.61,21.64c.63,1.18,2.24,1.37,3.14,.37l3.25-3.63c.8-.9,2.23-.85,2.96,.11l3.87,5.02c.69,.9,2.01,1.01,2.84,.23l5.85-5.46c.93-.87,.78-2.38-.3-3.05Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 76.1,
    y: 137.89,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(176.75 -12.65) rotate(60.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 76.1,
    y: 137.89,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(257.36 222.98) rotate(150.42)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 28.38,
    y: 103.12,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(1.64 -.75) rotate(.85)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 28.38,
    y: 103.12,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(162.98 60.82) rotate(90.85)"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 75.79,
    y: 69.55,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(-20.25 37.98) rotate(-19.76)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M170.46,77.53l-7.88,7.76c-.6,.59-.94,1.39-.97,2.24-.02,.45-.09,.96-.25,1.62-1.06,4.22-4.52,7.65-8.86,8.02-2.18,.19-4.23-.33-5.94-1.35-1.26-.75-2.87-.52-3.91,.51l-6.46,6.37c-.99,.98-.92,2.61,.16,3.49,5.18,4.19,12.15,6.31,19.62,5.02,10.13-1.75,18.2-10.05,19.71-20.23,.67-4.54,.11-8.87-1.44-12.72-.61-1.52-2.62-1.87-3.78-.72Zm-28.8,9.61c.04-5.52,4.52-9.93,10.04-9.89,1.93,.01,3.74,.57,5.26,1.53,1.25,.78,2.88,.54,3.93-.49l6.41-6.32c.98-.97,.92-2.59-.14-3.47-5.2-4.34-12.26-6.53-19.81-5.25-8.63,1.46-17.61,9.96-19.47,18.51-1.15,5.28-.58,10.35,1.25,14.77,.63,1.5,2.62,1.85,3.78,.71l8.83-8.7c-.07-.44-.09-.93-.09-1.39Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.48,47.9c38.22,26.81,35.95,86.2-4.28,109.98"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M129.26,42.37c.64,.31,1.27,.64,1.89,.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.14,157.69C14.59,126.47,30.48,43.44,93.21,34.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M80.44,162.26c-.64-.22-1.28-.45-1.91-.69"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M73.74,52.58c-2.87-9.33-2.32-25.62-2.32-25.62l-4.33-1.56s-9.98,12.89-18.16,18.23l-2.61,1.7c-2.36,6.55,2.79,11.25,10.87,14.27,8.14,2.84,15.11,2.51,17.47-4.03l-.92-2.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M68.62,47.86c-1.47-4.78-1.19-13.14-1.19-13.14l-2.22-.8s-5.12,6.61-9.31,9.35l-1.34,.87c-1.21,3.36,1.43,5.77,5.57,7.31,4.17,1.46,7.75,1.29,8.96-2.07l-.47-1.52Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 28.48,
    y: 95.78,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(.76 -.38) rotate(.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 28.48,
    y: 95.78,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(155.36 52.5) rotate(90.42)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 28.48,
    y: 89.66,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(.72 -.38) rotate(.42)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 28.48,
    y: 89.66,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(149.25 46.34) rotate(90.42)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "78.37 142.09 79.82 136.5 101.78 135.38 120.18 147.32 118.71 152.98 100.44 140.22 78.37 142.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "84.02 120.95 85.54 115.1 104.39 125.36 125.9 126 124.37 131.88 102.9 131.1 84.02 120.95"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 78.22,
    y: 129.44,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(169.32 -19.28) rotate(59.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 78.22,
    y: 129.44,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(257.66 204.99) rotate(149.99)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 79.76,
    y: 123.52,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(164.97 -23.57) rotate(59.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 79.76,
    y: 123.52,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(257.57 193.17) rotate(149.99)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M125.7,35.49c-3.58,0-6.48-4.63-6.48-6.8,0-.36-.77-.36-.77,0,0,2.08-2.67,6.8-6.89,6.8-.36,0-.36,.77,0,.77,3.68,0,6.89,5.04,6.89,6.8,0,.36,.77,.36,.77,0,0-2.09,2.99-6.8,6.48-6.8,.36,0,.36-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M70.91,126.02c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M43.11,53.38c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 73.01,
    y: 62.16,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(-18.16 37.45) rotate(-20.18)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 70.86,
    y: 56.44,
    width: 46.28,
    height: 15.16,
    rx: 1.97,
    ry: 1.97,
    transform: "translate(-16.32 36.36) rotate(-20.18)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "172.89 73.56 172.89 80.58 169.61 80.36 172.89 73.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "132.56 91.51 132.56 97.61 136.9 97.61 136.63 92.75 132.56 91.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "164.81 57.18 164.81 63.45 159.94 60.8 164.81 57.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "124.23 74.23 124.23 80.58 125.32 84.23 127.74 76.28 124.23 74.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M167.32,70.48l-7.82,7.82c-.6,.6-.92,1.4-.95,2.24-.02,.45-.08,.96-.24,1.62-1.03,4.23-4.47,7.68-8.8,8.09-2.18,.2-4.23-.3-5.95-1.31-1.26-.74-2.87-.5-3.9,.53l-6.41,6.41c-.99,.98-.9,2.62,.19,3.49,5.21,4.15,12.2,6.22,19.65,4.88,10.12-1.82,18.13-10.19,19.56-20.37,.64-4.54,.05-8.87-1.53-12.71-.62-1.51-2.63-1.85-3.79-.69Zm-28.73,9.82c0-5.52,4.45-9.97,9.97-9.97,1.93,0,3.74,.54,5.27,1.49,1.25,.78,2.89,.52,3.93-.52l6.36-6.36c.98-.98,.91-2.59-.16-3.47-5.23-4.3-12.31-6.44-19.85-5.1-8.62,1.52-17.53,10.09-19.33,18.66-1.11,5.28-.51,10.35,1.36,14.76,.64,1.5,2.63,1.83,3.78,.68l8.76-8.76c-.07-.44-.1-.93-.1-1.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M167.32,64.37l-7.82,7.82c-.6,.6-.92,1.4-.95,2.24-.02,.45-.08,.96-.24,1.62-1.03,4.23-4.47,7.68-8.8,8.09-2.18,.2-4.23-.3-5.95-1.31-1.26-.74-2.87-.5-3.9,.53l-6.41,6.41c-.99,.98-.9,2.62,.19,3.49,5.21,4.15,12.2,6.22,19.65,4.88,10.12-1.82,18.13-10.19,19.56-20.37,.64-4.54,.05-8.87-1.53-12.71-.62-1.51-2.63-1.85-3.79-.69Zm-28.73,9.82c0-5.52,4.45-9.97,9.97-9.97,1.93,0,3.74,.54,5.27,1.49,1.25,.78,2.89,.52,3.93-.52l6.36-6.36c.98-.98,.91-2.59-.16-3.47-5.23-4.3-12.31-6.44-19.85-5.1-8.62,1.52-17.53,10.09-19.33,18.66-1.11,5.28-.51,10.35,1.36,14.76,.64,1.5,2.63,1.83,3.78,.68l8.76-8.76c-.07-.44-.1-.93-.1-1.39Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "141.94 85.97 141.94 86 141.89 85.95 141.91 85.95 141.94 85.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "141.91 85.95 141.94 85.97 141.94 86 141.89 85.95 141.91 85.95"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.5,93.95c23.1,14.56,43.37,30.42,59.4,48.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M158.42,124.69l-6.04-3.73c-1.02-.63-1.23-2.03-.42-2.93l1.88-2.1c.97-1.09,.43-2.82-.99-3.16l-25.51-6.11c-1.62-.39-2.94,1.32-2.15,2.79l11.61,21.64c.63,1.18,2.24,1.37,3.14,.37l3.25-3.63c.8-.9,2.23-.85,2.96,.11l3.87,5.02c.69,.9,2.01,1.01,2.84,.23l5.85-5.46c.93-.87,.78-2.38-.3-3.05Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 145.87,
    cy: 117.21,
    r: 3.09
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH672);
export default __webpack_public_path__ + "static/media/H67-2.efdf99db5502b27dd3d3125f613c8738.svg";
export { ForwardRef as ReactComponent };